import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import { PaymentSchedule } from "./paymentSchedule"
import { IPaymentSchedule } from "./paymentSchedule.types"
import { PaymentSchedule as PaymentScheduleRaw } from "@/api/backofficeRest/generated/model"

dayjs.extend(utc)

// hasAuthorisedDirectDebit / hasAcceptedTerms are not returned by
// getPaymentScheduleDetails — they only exist on schedules built locally
// in the change-of-tenancy flow
export type IPaymentScheduleRaw = PaymentScheduleRaw & {
  hasAuthorisedDirectDebit?: boolean
  hasAcceptedTerms?: boolean
}

export const PaymentScheduleParser: IParser<
  IPaymentSchedule,
  IPaymentScheduleRaw
> = {
  toDomain: (data: IPaymentScheduleRaw) => {
    try {
      return new PaymentSchedule(
        data.id,
        data.amount,
        dayjs(data.createdAt),
        data.frequency,
        dayjs(data.frequencyAlignmentDt),
        data.frequencyMultiplier,
        dayjs.utc(data.fromDt),
        dayjs(data.nextPaymentDt),
        data.seasonalPaymentFl,
        data.hasAuthorisedDirectDebit ?? false,
        data.hasAcceptedTerms ?? false,
        data.toDt ? dayjs.utc(data.toDt) : undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
